import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ApplicationwizardComponent} from './components/applicationwizard/applicationwizard.component';
import {LoginComponent} from './login/login.component';
import {SignUpComponent} from './signup/signup.component';
import {ThankYouComponent} from './thankyou/thankyou.component';
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';
import { AuthGuard } from '../app/gaurds/auth.gaurd';

const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },

  {
    path: 'signup',
    component: SignUpComponent,
    data: {
      title: 'SignUp Page'
    }
  },

  {
    path: 'thankyou',
    component: ThankYouComponent,
    data: {
      title: 'Thank You Page'
    }
  },

  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password Page'
    }
  },

  { path: 'wizard', component: ApplicationwizardComponent, canActivate: [AuthGuard] }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
